<app-view-title Title="{{ 'Intellitrailer.Booking.SwapTrailer.Title' | translate : 'Change Trailer' }}" mode="split" webMode="primary"></app-view-title>
<view-content [centered]="true" [nopadding]="true">

  <div mobile-content>
    <p class="header-text">{{ 'Intellitrailer.Booking.SwapTrailer.txtHeaderInfoSwap' | translate : 'If your assigned trailer is missing or has a problem, use this option to replace it with another trailer at the station.' }} </p>

    <img src="/../../../../assets/Images/trailer-large.png" />
    <p>
      X: {{ 'Intellitrailer.Booking.SelectObject.TotalWeight' | translate : 'Total weight' }},
      Y: {{ 'Intellitrailer.Booking.SelectObject.LoadWeight' | translate : 'Load weight' }}<br />
      L: {{ 'Intellitrailer.Booking.SelectObject.Length' | translate : 'Length' }},
      W: {{ 'Intellitrailer.Booking.SelectObject.Width' | translate : 'Width' }},
      H: {{ 'Intellitrailer.Booking.SelectObject.Height' | translate : 'Height' }} 
    </p>
  </div>


  <content-header>
    @if(otherTypeObjects.length != 0 && primaryTypeObjects.length != 0){
    <p> {{ 'Intellitrailer.Booking.SwapTrailer.Header1' | translate : 'Select a new trailer from this location' }}</p>
    }
    @else if(otherTypeObjects.length == 0 && primaryTypeObjects.length == 0 && !loading){
    <p>{{ 'Intellitrailer.Booking.SwapTrailer.Header2' | translate : 'No other trailers available' }}</p>
    }
  </content-header>

  <data-list>

    @if(loading){
    <div web-content class="componentLoader">
      <mat-progress-spinner diameter="75" mode="indeterminate" class="inverted-spinner"></mat-progress-spinner>
    </div>
    <div mobile-content class="componentLoader">
      <mat-progress-spinner diameter="75" mode="indeterminate"></mat-progress-spinner>
      @if(swappingLoading){
      <p> {{ 'Intellitraieler.Booking.SwapTrailer.txtChaningTrailer' | translate : 'Changing trailer...'}}</p>
      }
    </div>
    }

    @if(swapCompleted){
    <div>
      <p>{{ 'Intellitrailer.Booking.SwapTrailer.SwapCompleted' | translate : 'Completed the change, you will be redireacted back to the start screen in a moment...' }}</p>
      <div class="save-completed-container checkmark-container">
        <!-- Content of the element that will be animated -->
        <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
          <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
        </svg>
      </div>
    </div>
    }
    @if(swapError){
    <div>
      <p>{{ 'Intellitrailer.Booking.SwapTrailer.SwapError' | translate : 'Something went wrong with the change, the selected trailer isn't avaivable anymore for a change...' }}</p>
    </div>
    }
    @if(!swapCompleted && !loading){
    @if(!swapCompleted && !loading){
    <!-- Same type of rental object -->
    @for( object of primaryTypeObjects; track object.Type.Id){

    <app-card web-content>
      <img src="{{ object.Type.PictureUri }}" />
      <div class="title-with-divider">
        <div class="title">{{object.Type.Alias}}</div>
      </div>

      <div class="row" style="text-align:left">
        <div class="col-7 overflow-text">RegNo</div>
        <div class="col-5 text-md-right" style="white-space:nowrap">{{ object.Title }}</div>
      </div>
      <div class="row" style="text-align:left">
        <div class="col-8 overflow-text">
          {{ 'Intellitrailer.Booking.Components.BookingOption.Length' | translate : 'Length'}}
        </div>
        <div class="col-4 text-md-right" style="white-space:nowrap">
          {{ object?.Type?.Length != null && object.Type.Length !== '' ? (object.Type.Length + 'cm') : '' }}
        </div>
      </div>
      <div class="row" style="text-align:left">
        <div class="col-8 overflow-text">
          {{ 'Intellitrailer.Booking.Components.BookingOption.Width' | translate : 'Width'}}
        </div>
        <div class="col-4 text-md-right" style="white-space:nowrap">
          {{ object?.Type?.Width != null && object.Type.Width !== '' ? (object.Type.Width + 'cm') : '' }}
        </div>
      </div>
      <div class="row" style="text-align:left">
        <div class="col-8 overflow-text">
          {{ 'Intellitrailer.Booking.Components.BookingOption.Height' | translate : 'Height'}}
        </div>
        <div class="col-4 text-md-right" style="white-space:nowrap">
          {{ object?.Type?.Height != null && object.Type.Height !== '' ? (object.Type.Height + 'cm') : '' }}
        </div>
      </div>
      <div class="row" style="text-align:left">
        <div class="col-8 overflow-text">
          {{ 'tIntellitrailer.Booking.Components.BookingOption.TotalWeight' | translate : 'TotalWeight'}}
        </div>
        <div class="col-4 text-md-right" style="white-space:nowrap">
          {{ object?.Type?.TotalWeight != null && object.Type.TotalWeight !== '' ? (object.Type.TotalWeight + 'kg') : '' }}
        </div>
      </div>
      <div class="row" style="text-align:left">
        <div class="col-8 overflow-text">
          {{ 'tIntellitrailer.Booking.Components.BookingOption.LoadWeight' | translate : 'LoadWeight'}}
        </div>
        <div class="col-4 text-md-right" style="white-space:nowrap">
          {{ object?.Type?.MaxLoad != null && object.Type.MaxLoad !== '' ? (object.Type.MaxLoad + 'kg') : '' }}
        </div>
      </div>
      <div class="title-with-divider"></div>
      <button mat-raised-button  (click)="initiateSwap(object)">
        {{ 'tIntellitrailer.Booking.Components.BookingOption.Select' | translate : 'Select'}}
      </button>
    </app-card>
    }
    }
    <!-- Other Types -->
    @for(object of otherTypeObjects; track object.Type.Id){
    <app-card web-content>
      <img src="{{ object.Type.PictureUri }}" />
      <div class="title-with-divider">
        <div class="title">{{object.Type.Alias}}</div>
      </div>

      <div class="row" style="text-align:left">
        <div class="col-8 overflow-text">RegNo</div>
        <div class="col-4 text-md-right" style="white-space:nowrap">{{ object.Title }}</div>
      </div>
      <div class="row" style="text-align:left">
        <div class="col-8 overflow-text">
          {{ 'Intellitrailer.Booking.Components.BookingOption.Length' | translate : 'Length'}}
        </div>
        <div class="col-4 text-md-right" style="white-space:nowrap">
          {{ object?.Type?.Length != null && object.Type.Length !== '' ? (object.Type.Length + 'cm') : '' }}
        </div>
      </div>
      <div class="row" style="text-align:left">
        <div class="col-8 overflow-text">
          {{ 'Intellitrailer.Booking.Components.BookingOption.Width' | translate : 'Width'}}
        </div>
        <div class="col-4 text-md-right" style="white-space:nowrap">
          {{ object?.Type?.Width != null && object.Type.Width !== '' ? (object.Type.Width + 'cm') : '' }}
        </div>
      </div>
      <div class="row" style="text-align:left">
        <div class="col-8 overflow-text">
          {{ 'Intellitrailer.Booking.Components.BookingOption.Height' | translate : 'Height'}}
        </div>
        <div class="col-4 text-md-right" style="white-space:nowrap">
          {{ object?.Type?.Height != null && object.Type.Height !== '' ? (object.Type.Height + 'cm') : '' }}
        </div>
      </div>
      <div class="row" style="text-align:left">
        <div class="col-8 overflow-text">
          {{ 'tIntellitrailer.Booking.Components.BookingOption.TotalWeight' | translate : 'TotalWeight'}}
        </div>
        <div class="col-4 text-md-right" style="white-space:nowrap">
          {{ object?.Type?.TotalWeight != null && object.Type.TotalWeight !== '' ? (object.Type.TotalWeight + 'kg') : '' }}
        </div>
      </div>
      <div class="row" style="text-align:left">
        <div class="col-8 overflow-text">
          {{ 'tIntellitrailer.Booking.Components.BookingOption.LoadWeight' | translate : 'LoadWeight'}}
        </div>
        <div class="col-4 text-md-right" style="white-space:nowrap">
          {{ object?.Type?.MaxLoad != null && object.Type.MaxLoad !== '' ? (object.Type.MaxLoad + 'kg') : '' }}
        </div>
      </div>

      <div class="title-with-divider"></div>
      <button mat-raised-button (click)="initiateSwap(object)">
        {{ 'tIntellitrailer.Booking.Components.BookingOption.Select' | translate : 'Select'}}
        @if(object.priceModel && (object.priceModel.DiscountedTotalPrice - booking.Price.DiscountedTotalPrice) != 0){
        <span>({{ (object.priceModel.DiscountedTotalPrice - booking.Price.DiscountedTotalPrice) > 0 ? '+' : '' }} {{ object.priceModel.DiscountedTotalPrice - booking.Price.DiscountedTotalPrice | currency }} )</span>
        }
      </button>
    </app-card>
    }
    <!-- Mobile Content-->
    <!-- SAME TYPE -->
    @if (hasPrimary  && !loading) {
    <div mobile-content class="title-with-divider">
      <div class="title">
        {{ 'Intellitrailer.Booking.SwapTrailer.MobileHeader1' | translate : 'Same type' }}
      </div>
    </div>

    @for (group of groupedObjects; track group.type.Id) {
    @if (group.isPrimary) {
    <div mobile-content>
      <list-item>
        <div>
          <div class="row divider-margin">
            <div class="col-3">
              <div class="img-center-box">
                <img [src]="group?.type?.PictureUri ? group.type.PictureUri : null">
                </div>
              </div>

              <div class="col-9">
                <div class="row">
                  <div class="col-9">
                    {{ group.type.Alias }}
                  </div>
                  <div class="col-12">
                    L: {{ group.type.Length }}cm, W: {{ group.type.Width }}cm, H: {{ group.type.Height }}cm
                  </div>
                  <div class="col-12">
                    X: {{ group.type.TotalWeight }}kg, Y: {{ group.type.MaxLoad }}kg
                  </div>
                </div>
              </div>
            </div>

          <mat-divider></mat-divider>

          <div class="row full-width">
            <div class="col regno-container">
              @for (rentalObject of group.objects; track rentalObject.Id; let isLast = $last) {
              <div
                   (click)="initiateSwap(rentalObject)">
                <mat-icon style="vertical-align:bottom">arrow_right</mat-icon>
                {{ rentalObject.Title }}

                <button mat-stroked-button> Select </button>
              </div>
              @if (!isLast) { <mat-divider></mat-divider> }
              }
            </div>
          </div>
        </div>
      </list-item>
    </div>
    }
    }
    }

    <!-- OTHER TRAILERS -->
    @if (hasOthers && !loading) {
    <div mobile-content class="title-with-divider">
      <div class="title">
        {{ 'Intellitrailer.Booking.SwapTrailer.TitleOther' | translate : 'Other trailers' }}
      </div>
    </div>

    @for (group of groupedObjects; track group.type.Id) {
    @if (!group.isPrimary) {
    <!-- reuse the exact same card markup as above -->
    <div mobile-content>
      <list-item>
        <div>
          <div class="row divider-margin">
            <div class="col-3">
              <div class="img-center-box">
                <img [src]="group?.type?.PictureUri ? group.type.PictureUri : null">
              </div>
            </div>

            <div class="col-9">
              <div class="row propertyRow">
                <div class="col-9 booking-option-title">
                  {{ group.type.Alias }}
                </div>
                <div class="col-12 booking-option-distance">
                  L: {{ group.type.Length }}cm, W: {{ group.type.Width }}cm, H: {{ group.type.Height }}cm
                </div>
                <div class="col-12 booking-option-distance">
                  X: {{ group.type.TotalWeight }}kg, Y: {{ group.type.MaxLoad }}kg
                </div>
                @if(loadingPrice){
                <div class="col-12 booking-option-distance">
                  <mat-progress-spinner diameter="25" mode="indeterminate"></mat-progress-spinner>
                  @if(group.priceModel && (group.priceModel.DiscountedTotalPrice - booking.Price.DiscountedTotalPrice) != 0){
                  <span>
                    {{ 'Intellitrailer.Booking.SwapTrailer.TxtPriceDifference:' | translate : 'Price difference: ' }}
                    {{ (group.priceModel.DiscountedTotalPrice - booking.Price.DiscountedTotalPrice) > 0 ? '+' : '-' }}
                    {{ group.priceModel.DiscountedTotalPrice - booking.Price.DiscountedTotalPrice | currency }}
                  </span>
                  }
                </div>
                }
              </div>
            </div>
          </div>

          <mat-divider></mat-divider>

          <div class="row full-width">
            <div class="col regno-container">
              @for (rentalObject of group.objects; track rentalObject.Id; let isLast = $last) {
              <div (click)="initiateSwap(rentalObject)">
                <div class="regno-title">
                  <mat-icon style="vertical-align:bottom">arrow_right</mat-icon>
                  {{ rentalObject.Title }}
                </div>

                <button mat-stroked-button> Select </button>
              </div>
              @if (!isLast) { <mat-divider></mat-divider> }
              }
            </div>
          </div>
        </div>
      </list-item>
    </div>
    }
    }
    }

    @if(otherTypeObjects.length == 0 && primaryTypeObjects.length == 0 && !loading){
    <div mobile-content class="title-with-divider">
      <div class="title">{{ 'Intellitrailer.Booking.SwapTrailer.TitleNoOtherTrailers' | translate : 'No other trailers available' }}</div>
    </div>
    <button mat-raised-button (click)="back()"> {{ 'Intellitrailer.Booking.SwapTrailer.BackButton' | translate : 'Go back ' }}</button>
    }
    }
  </data-list>
</view-content>

<view-actions mode="white"> 
</view-actions>

